<template>
  <div class="container-d image-card">  
    <div class="container-documents">  
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-6 col-xl-6 col-12" v-for="(c, ix) in cardText" :key="`card_${ix}`">
          <div>
            <ImageElement :imageData="imageDataScroll(c)" />
          </div>
          <div v-if="c.text" class="text-left creditos-picture">
            <span v-html="c.text" v-if="c.text"></span>
            <span class="author">{{ c.imageCredits }}</span>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>

<style lang="scss">
  .container-d {
    margin: 25px 0;
    padding: 65px 15px;
    background: #1e20228f;
  }

  .container-documents {
    max-width: 920px;
    width: 100%;
    margin: 0 auto;
  }
.creditos-picture {
  font-family: "Noto Sans";
  padding: 15px;
  color: #fff;
  font-size: 14px;
  
  span {
    color: #fff;
    font-size: 15px;
  }
  
  .author {
    font-size: 14px;
    color: #fff;
  }
}
</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'StoryImages',
    mixins: [images],
    props: {
      cardText: [Object, Array] 
    }
  }
</script>